import {useEffect, useState} from "react";
import {client} from "../client";

export default function useFetchSanity (type)  {
    const [state, setState] = useState([])

    useEffect(() => {
        const query = `*[_type=="${type}"]`;

        //fetching from sanity schemas
        client.fetch(query).then((data) => setState(data))
    }, [])

    return {state, setState};
}

